import joinUrl from "../../utils/join-url";
import requestUtility from "../../helpers/request-utility";
import credentialTypes from "../../constants/credentials";
import extractTypes from "../../constants/extract-types";

const deleteBillingProfile = (apiUrl) => (id) => {
  const url = joinUrl(apiUrl, `/checkoutservice/pb/billing-profiles/${id}/`);
  return requestUtility.delete(url, credentialTypes.INCLUDE, extractTypes.TEXT);
};

export default deleteBillingProfile;
